import React from 'react';
import {
  Button,
  createTableColumn,
  TableCellLayout,
  Text,
  Tooltip,
} from '@fluentui/react-components';
import {
  EditRegular,
} from '@fluentui/react-icons';
// import { HelpButton } from '@bingads-webui-react/help-popup';
import { countries } from '../../common/countries';
import { StatusBadge } from '../status-badge';
import { DeleteStudyDialog } from './delete-study-dialog';
import {
  statuses,
  STATUS_COMPLETED,
  STATUS_SCHEDULED,
} from '../statuses';

/*
const getHelpButton = (headerName, topic) => {
  const stopPropagation = (e) => { e.stopPropagation(); };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <span onClick={stopPropagation} onKeyDown={stopPropagation}>
      <HelpButton
        aria-label={headerName}
        topic={topic}
      />
    </span>
  );
};

const getHeaderCell = (i18n, name, topic) => {
  const headerName = i18n.getString(_TL_('{{name}}'), { name });
  return (
    <> {headerName} {getHelpButton(headerName, topic)} </>
  );
};
*/

const getCountryName = ({ country, i18n }) => i18n.getString(countries[country].name);

export const getColumns = ({
  i18n,
  onClickDelete,
  onClickEdit,
  onClickName,
}) => [
  createTableColumn({
    columnId: 'Name',
    compare: (a, b) => a.Name.localeCompare(b.Name),
    renderCell: (item) => {
      const experimentName = item.Status === STATUS_COMPLETED
        ? (
          <Text
            onClick={() => onClickName({
              id: item.Id,
              name: item.Name,
            })}
            style={{ cursor: 'pointer' }}
            underline
          >
            {item.Name}
          </Text>
        )
        : item.Name;
      const instructions = i18n.getString(_TL_('Click to view the results for experiment "{{name}}".'), {
        name: item.Name,
      });

      return (
        <Tooltip
          content={item.Status === STATUS_COMPLETED ? instructions : item.Name}
          relationship="description"
          withArrow
        >
          <TableCellLayout
            className="experiment-name"
            truncate
          >
            {experimentName}
          </TableCellLayout>
        </Tooltip>
      );
    },
    // renderHeaderCell: () => getHeaderCell(i18n, 'Experiment name', 'pop_BA_Experiments_Name'),
    renderHeaderCell: () => i18n.getString(_TL_('Experiment name')),
  }),
  createTableColumn({
    columnId: 'Status',
    renderCell: (item) => {
      const infoTextData = { name: item.Name };

      if (item.Status === STATUS_SCHEDULED) {
        infoTextData.startDate = item.StartDate;
      }

      return (
        <TableCellLayout>
          <StatusBadge
            code={item.Status}
            infoTextData={infoTextData}
            text={statuses[item.Status].name}
          />
        </TableCellLayout>
      );
    },
    // renderHeaderCell: () => getHeaderCell(i18n, 'Status', 'pop_BA_Experiments_Status'),
    renderHeaderCell: () => i18n.getString(_TL_('Status')),
  }),
  createTableColumn({
    columnId: 'Campaigns',
    renderCell: (item) => {
      const campaignNames = item.Campaigns.map(campaign => campaign.Name);
      const campaignNamesString = campaignNames.join(i18n.getString(_TL_(', ')));
      return (
        <Tooltip
          content={campaignNamesString}
          relationship="description"
          withArrow
        >
          <TableCellLayout truncate>
            {campaignNamesString}
          </TableCellLayout>
        </Tooltip>
      );
    },
    // renderHeaderCell: () => getHeaderCell(i18n, 'Campaigns', 'pop_BA_Experiments_Campaigns'),
    renderHeaderCell: () => i18n.getString(_TL_('Campaigns')),
  }),
  createTableColumn({
    columnId: 'dates',
    compare: (a, b) => a.StartDate.localeCompare(b.StartDate),
    renderCell: (item) => {
      const dateRangeString = `${i18n.formatDate(new Date(item.StartDate))} - ${i18n.formatDate(new Date(item.EndDate))}`;
      return (
        <Tooltip
          content={dateRangeString}
          relationship="description"
          withArrow
        >
          <TableCellLayout truncate>
            {dateRangeString}
          </TableCellLayout>
        </Tooltip>
      );
    },
    // renderHeaderCell: () => getHeaderCell(i18n, 'Experiment dates', 'pop_BA_Experiments_Dates'),
    renderHeaderCell: () => i18n.getString(_TL_('Experiment dates')),
  }),
  createTableColumn({
    columnId: 'Country',
    compare: (a, b) => getCountryName({ country: a.Country, i18n }).localeCompare(getCountryName({ country: b.Country, i18n })),
    renderCell: (item) => {
      const countryString = getCountryName({ country: item.Country, i18n });
      return (
        <Tooltip
          content={countryString}
          relationship="description"
          withArrow
        >
          <TableCellLayout truncate>
            {countryString}
          </TableCellLayout>
        </Tooltip>
      );
    },
    // renderHeaderCell: () => getHeaderCell(i18n, 'Country', 'pop_BA_Experiments_Country'),
    renderHeaderCell: () => i18n.getString(_TL_('Country')),
  }),
  createTableColumn({
    columnId: 'actions',
    renderCell: item => (
      <TableCellLayout>
        <Button
          className="edit-experiment"
          aria-label={i18n.getString(_TL_('Edit'))}
          disabled={item.Status !== STATUS_SCHEDULED}
          icon={<EditRegular />}
          onClick={() => {
            onClickEdit(item.Id);
          }}
        />
        <DeleteStudyDialog
          onDelete={() => onClickDelete(item.Id)}
          name={item.Name}
          status={item.Status}
        />
      </TableCellLayout>
    ),
    renderHeaderCell: () => i18n.getString(_TL_('Actions')),
  }),
];

export const getCellFocusMode = (columnId) => {
  if (columnId === 'status' || columnId === 'campaigns') {
    return 'none';
  }

  if (columnId === 'actions') {
    return 'group';
  }

  return 'cell';
};
